export function textTabsMedia() {
    const ttmLarge = document.querySelector('.text-tabs-media-large');
    const supportsAnimationTimeline = CSS.supports('animation-timeline', 'view()');
    
    if (!ttmLarge || window.innerWidth < 1024 || !supportsAnimationTimeline) return;

    const ttmLargePanels = document.querySelectorAll('[class*="text-tabs-media-large-panel-"]');
    const scrollPositions = [0, 2, 4]; // 0%, 50%, 100% of sticky range

    function handlePanelClick(index) {
        const ttmLargeTop = ttmLarge.offsetTop;
        const headerHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10);
        const targetPosition = ttmLargeTop + ((window.innerHeight * scrollPositions[index]) + headerHeight);
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    }

    ttmLargePanels.forEach((panel, index) => {
        panel.addEventListener('click', () => handlePanelClick(index));
    });
}